import TrancheEffectif from '@/generated/classes/TrancheEffectif';
export default class TrancheEffectifExtend extends TrancheEffectif {
  constructor() {
    super();
  }
}
